export default [
  {
    label: "Afrikaans",
    value: "af"
  },
  {
    label: "Afrikaans (South Africa)",
    value: "af-ZA"
  },
  {
    label: "Arabic",
    value: "ar"
  },
  {
    label: "Arabic (U.A.E.)",
    value: "ar-AE"
  },
  {
    label: "Arabic (Bahrain)",
    value: "ar-BH"
  },
  {
    label: "Arabic (Algeria)",
    value: "ar-DZ"
  },
  {
    label: "Arabic (Egypt)",
    value: "ar-EG"
  },
  {
    label: "Arabic (Iraq)",
    value: "ar-IQ"
  },
  {
    label: "Arabic (Jordan)",
    value: "ar-JO"
  },
  {
    label: "Arabic (Kuwait)",
    value: "ar-KW"
  },
  {
    label: "Arabic (Lebanon)",
    value: "ar-LB"
  },
  {
    label: "Arabic (Libya)",
    value: "ar-LY"
  },
  {
    label: "Arabic (Morocco)",
    value: "ar-MA"
  },
  {
    label: "Arabic (Oman)",
    value: "ar-OM"
  },
  {
    label: "Arabic (Qatar)",
    value: "ar-QA"
  },
  {
    label: "Arabic (Saudi Arabia)",
    value: "ar-SA"
  },
  {
    label: "Arabic (Syria)",
    value: "ar-SY"
  },
  {
    label: "Arabic (Tunisia)",
    value: "ar-TN"
  },
  {
    label: "Arabic (Yemen)",
    value: "ar-YE"
  },
  {
    label: "Azeri (Latin)",
    value: "az"
  },
  {
    label: "Azeri (Latin) (Azerbaijan)",
    value: "az-AZ"
  },
  {
    label: "Azeri (Cyrillic) (Azerbaijan)",
    value: "az-Cyrl-AZ"
  },
  {
    label: "Belarusian",
    value: "be"
  },
  {
    label: "Belarusian (Belarus)",
    value: "be-BY"
  },
  {
    label: "Bulgarian",
    value: "bg"
  },
  {
    label: "Bulgarian (Bulgaria)",
    value: "bg-BG"
  },
  {
    label: "Bosnian (Bosnia and Herzegovina)",
    value: "bs-BA"
  },
  {
    label: "Catalan",
    value: "ca"
  },
  {
    label: "Catalan (Spain)",
    value: "ca-ES"
  },
  {
    label: "Czech",
    value: "cs"
  },
  {
    label: "Czech (Czech Republic)",
    value: "cs-CZ"
  },
  {
    label: "Welsh",
    value: "cy"
  },
  {
    label: "Welsh (United Kingdom)",
    value: "cy-GB"
  },
  {
    label: "Danish",
    value: "da"
  },
  {
    label: "Danish (Denmark)",
    value: "da-DK"
  },
  {
    label: "German",
    value: "de"
  },
  {
    label: "German (Austria)",
    value: "de-AT"
  },
  {
    label: "German (Switzerland)",
    value: "de-CH"
  },
  {
    label: "German (Germany)",
    value: "de-DE"
  },
  {
    label: "German (Liechtenstein)",
    value: "de-LI"
  },
  {
    label: "German (Luxembourg)",
    value: "de-LU"
  },
  {
    label: "Divehi",
    value: "dv"
  },
  {
    label: "Divehi (Maldives)",
    value: "dv-MV"
  },
  {
    label: "Greek",
    value: "el"
  },
  {
    label: "Greek (Greece)",
    value: "el-GR"
  },
  {
    label: "English",
    value: "en"
  },
  {
    label: "English (Australia)",
    value: "en-AU"
  },
  {
    label: "English (Belize)",
    value: "en-BZ"
  },
  {
    label: "English (Canada)",
    value: "en-CA"
  },
  {
    label: "English (Caribbean)",
    value: "en-CB"
  },
  {
    label: "English (United Kingdom)",
    value: "en-GB"
  },
  {
    label: "English (Ireland)",
    value: "en-IE"
  },
  {
    label: "English (Jamaica)",
    value: "en-JM"
  },
  {
    label: "English (New Zealand)",
    value: "en-NZ"
  },
  {
    label: "English (Republic of the Philippines)",
    value: "en-PH"
  },
  {
    label: "English (Trinidad and Tobago)",
    value: "en-TT"
  },
  {
    label: "English (United States)",
    value: "en-US"
  },
  {
    label: "English (South Africa)",
    value: "en-ZA"
  },
  {
    label: "English (Zimbabwe)",
    value: "en-ZW"
  },
  {
    label: "Esperanto",
    value: "eo"
  },
  {
    label: "Spanish",
    value: "es"
  },
  {
    label: "Spanish (Argentina)",
    value: "es-AR"
  },
  {
    label: "Spanish (Bolivia)",
    value: "es-BO"
  },
  {
    label: "Spanish (Chile)",
    value: "es-CL"
  },
  {
    label: "Spanish (Colombia)",
    value: "es-CO"
  },
  {
    label: "Spanish (Costa Rica)",
    value: "es-CR"
  },
  {
    label: "Spanish (Dominican Republic)",
    value: "es-DO"
  },
  {
    label: "Spanish (Ecuador)",
    value: "es-EC"
  },
  {
    label: "Spanish (Spain)",
    value: "es-ES"
  },
  {
    label: "Spanish (Guatemala)",
    value: "es-GT"
  },
  {
    label: "Spanish (Honduras)",
    value: "es-HN"
  },
  {
    label: "Spanish (Mexico)",
    value: "es-MX"
  },
  {
    label: "Spanish (Nicaragua)",
    value: "es-NI"
  },
  {
    label: "Spanish (Panama)",
    value: "es-PA"
  },
  {
    label: "Spanish (Peru)",
    value: "es-PE"
  },
  {
    label: "Spanish (Puerto Rico)",
    value: "es-PR"
  },
  {
    label: "Spanish (Paraguay)",
    value: "es-PY"
  },
  {
    label: "Spanish (El Salvador)",
    value: "es-SV"
  },
  {
    label: "Spanish (Uruguay)",
    value: "es-UY"
  },
  {
    label: "Spanish (Venezuela)",
    value: "es-VE"
  },
  {
    label: "Estonian",
    value: "et"
  },
  {
    label: "Estonian (Estonia)",
    value: "et-EE"
  },
  {
    label: "Basque",
    value: "eu"
  },
  {
    label: "Basque (Spain)",
    value: "eu-ES"
  },
  {
    label: "Farsi",
    value: "fa"
  },
  {
    label: "Farsi (Iran)",
    value: "fa-IR"
  },
  {
    label: "Finnish",
    value: "fi"
  },
  {
    label: "Finnish (Finland)",
    value: "fi-FI"
  },
  {
    label: "Faroese",
    value: "fo"
  },
  {
    label: "Faroese (Faroe Islands)",
    value: "fo-FO"
  },
  {
    label: "French",
    value: "fr"
  },
  {
    label: "French (Belgium)",
    value: "fr-BE"
  },
  {
    label: "French (Canada)",
    value: "fr-CA"
  },
  {
    label: "French (Switzerland)",
    value: "fr-CH"
  },
  {
    label: "French (France)",
    value: "fr-FR"
  },
  {
    label: "French (Luxembourg)",
    value: "fr-LU"
  },
  {
    label: "French (Principality of Monaco)",
    value: "fr-MC"
  },
  {
    label: "Galician",
    value: "gl"
  },
  {
    label: "Galician (Spain)",
    value: "gl-ES"
  },
  {
    label: "Gujarati",
    value: "gu"
  },
  {
    label: "Gujarati (India)",
    value: "gu-IN"
  },
  {
    label: "Hebrew",
    value: "he"
  },
  {
    label: "Hebrew (Israel)",
    value: "he-IL"
  },
  {
    label: "Hindi",
    value: "hi"
  },
  {
    label: "Hindi (India)",
    value: "hi-IN"
  },
  {
    label: "Croatian",
    value: "hr"
  },
  {
    label: "Croatian (Bosnia and Herzegovina)",
    value: "hr-BA"
  },
  {
    label: "Croatian (Croatia)",
    value: "hr-HR"
  },
  {
    label: "Hungarian",
    value: "hu"
  },
  {
    label: "Hungarian (Hungary)",
    value: "hu-HU"
  },
  {
    label: "Armenian",
    value: "hy"
  },
  {
    label: "Armenian (Armenia)",
    value: "hy-AM"
  },
  {
    label: "Indonesian",
    value: "id"
  },
  {
    label: "Indonesian (Indonesia)",
    value: "id-ID"
  },
  {
    label: "Icelandic",
    value: "is"
  },
  {
    label: "Icelandic (Iceland)",
    value: "is-IS"
  },
  {
    label: "Italian",
    value: "it"
  },
  {
    label: "Italian (Switzerland)",
    value: "it-CH"
  },
  {
    label: "Italian (Italy)",
    value: "it-IT"
  },
  {
    label: "Japanese",
    value: "ja"
  },
  {
    label: "Japanese (Japan)",
    value: "ja-JP"
  },
  {
    label: "Georgian",
    value: "ka"
  },
  {
    label: "Georgian (Georgia)",
    value: "ka-GE"
  },
  {
    label: "Kazakh",
    value: "kk"
  },
  {
    label: "Kazakh (Kazakhstan)",
    value: "kk-KZ"
  },
  {
    label: "Kannada",
    value: "kn"
  },
  {
    label: "Kannada (India)",
    value: "kn-IN"
  },
  {
    label: "Korean",
    value: "ko"
  },
  {
    label: "Korean (Korea)",
    value: "ko-KR"
  },
  {
    label: "Konkani",
    value: "kok"
  },
  {
    label: "Konkani (India)",
    value: "kok-IN"
  },
  {
    label: "Kyrgyz",
    value: "ky"
  },
  {
    label: "Kyrgyz (Kyrgyzstan)",
    value: "ky-KG"
  },
  {
    label: "Lithuanian",
    value: "lt"
  },
  {
    label: "Lithuanian (Lithuania)",
    value: "lt-LT"
  },
  {
    label: "Latvian",
    value: "lv"
  },
  {
    label: "Latvian (Latvia)",
    value: "lv-LV"
  },
  {
    label: "Maori",
    value: "mi"
  },
  {
    label: "Maori (New Zealand)",
    value: "mi-NZ"
  },
  {
    label: "FYRO Macedonian",
    value: "mk"
  },
  {
    label: "FYRO Macedonian (Former Yugoslav Republic of Macedonia)",
    value: "mk-MK"
  },
  {
    label: "Mongolian",
    value: "mn"
  },
  {
    label: "Mongolian (Mongolia)",
    value: "mn-MN"
  },
  {
    label: "Marathi",
    value: "mr"
  },
  {
    label: "Marathi (India)",
    value: "mr-IN"
  },
  {
    label: "Malay",
    value: "ms"
  },
  {
    label: "Malay (Brunei Darussalam)",
    value: "ms-BN"
  },
  {
    label: "Malay (Malaysia)",
    value: "ms-MY"
  },
  {
    label: "Maltese",
    value: "mt"
  },
  {
    label: "Maltese (Malta)",
    value: "mt-MT"
  },
  {
    label: "Norwegian (Bokm?l)",
    value: "nb"
  },
  {
    label: "Norwegian (Bokm?l) (Norway)",
    value: "nb-NO"
  },
  {
    label: "Dutch",
    value: "nl"
  },
  {
    label: "Dutch (Belgium)",
    value: "nl-BE"
  },
  {
    label: "Dutch (Netherlands)",
    value: "nl-NL"
  },
  {
    label: "Norwegian (Nynorsk) (Norway)",
    value: "nn-NO"
  },
  {
    label: "Northern Sotho",
    value: "ns"
  },
  {
    label: "Northern Sotho (South Africa)",
    value: "ns-ZA"
  },
  {
    label: "Punjabi",
    value: "pa"
  },
  {
    label: "Punjabi (India)",
    value: "pa-IN"
  },
  {
    label: "Polish",
    value: "pl"
  },
  {
    label: "Polish (Poland)",
    value: "pl-PL"
  },
  {
    label: "Pashto",
    value: "ps"
  },
  {
    label: "Pashto (Afghanistan)",
    value: "ps-AR"
  },
  {
    label: "Portuguese",
    value: "pt"
  },
  {
    label: "Portuguese (Brazil)",
    value: "pt-BR"
  },
  {
    label: "Portuguese (Portugal)",
    value: "pt-PT"
  },
  {
    label: "Quechua",
    value: "qu"
  },
  {
    label: "Quechua (Bolivia)",
    value: "qu-BO"
  },
  {
    label: "Quechua (Ecuador)",
    value: "qu-EC"
  },
  {
    label: "Quechua (Peru)",
    value: "qu-PE"
  },
  {
    label: "Romanian",
    value: "ro"
  },
  {
    label: "Romanian (Romania)",
    value: "ro-RO"
  },
  {
    label: "Russian",
    value: "ru"
  },
  {
    label: "Russian (Russia)",
    value: "ru-RU"
  },
  {
    label: "Sanskrit",
    value: "sa"
  },
  {
    label: "Sanskrit (India)",
    value: "sa-IN"
  },
  {
    label: "Sami",
    value: "se"
  },
  {
    label: "Sami (Finland)",
    value: "se-FI"
  },
  {
    label: "Sami (Norway)",
    value: "se-NO"
  },
  {
    label: "Sami (Sweden)",
    value: "se-SE"
  },
  {
    label: "Slovak",
    value: "sk"
  },
  {
    label: "Slovak (Slovakia)",
    value: "sk-SK"
  },
  {
    label: "Slovenian",
    value: "sl"
  },
  {
    label: "Slovenian (Slovenia)",
    value: "sl-SI"
  },
  {
    label: "Albanian",
    value: "sq"
  },
  {
    label: "Albanian (Albania)",
    value: "sq-AL"
  },
  {
    label: "Serbian (Latin) (Bosnia and Herzegovina)",
    value: "sr-BA"
  },
  {
    label: "Serbian (Cyrillic) (Bosnia and Herzegovina)",
    value: "sr-Cyrl-BA"
  },
  {
    label: "Serbian (Latin) (Serbia and Montenegro)",
    value: "sr-SP"
  },
  {
    label: "Serbian (Cyrillic) (Serbia and Montenegro)",
    value: "sr-Cyrl-SP"
  },
  {
    label: "Swedish",
    value: "sv"
  },
  {
    label: "Swedish (Finland)",
    value: "sv-FI"
  },
  {
    label: "Swedish (Sweden)",
    value: "sv-SE"
  },
  {
    label: "Swahili",
    value: "sw"
  },
  {
    label: "Swahili (Kenya)",
    value: "sw-KE"
  },
  {
    label: "Syriac",
    value: "syr"
  },
  {
    label: "Syriac (Syria)",
    value: "syr-SY"
  },
  {
    label: "Tamil",
    value: "ta"
  },
  {
    label: "Tamil (India)",
    value: "ta-IN"
  },
  {
    label: "Telugu",
    value: "te"
  },
  {
    label: "Telugu (India)",
    value: "te-IN"
  },
  {
    label: "Thai",
    value: "th"
  },
  {
    label: "Thai (Thailand)",
    value: "th-TH"
  },
  {
    label: "Tagalog",
    value: "tl"
  },
  {
    label: "Tagalog (Philippines)",
    value: "tl-PH"
  },
  {
    label: "Tswana",
    value: "tn"
  },
  {
    label: "Tswana (South Africa)",
    value: "tn-ZA"
  },
  {
    label: "Turkish",
    value: "tr"
  },
  {
    label: "Turkish (Turkey)",
    value: "tr-TR"
  },
  {
    label: "Tatar",
    value: "tt"
  },
  {
    label: "Tatar (Russia)",
    value: "tt-RU"
  },
  {
    label: "Tsonga",
    value: "ts"
  },
  {
    label: "Ukrainian",
    value: "uk"
  },
  {
    label: "Ukrainian (Ukraine)",
    value: "uk-UA"
  },
  {
    label: "Urdu",
    value: "ur"
  },
  {
    label: "Urdu (Islamic Republic of Pakistan)",
    value: "ur-PK"
  },
  {
    label: "Uzbek (Latin)",
    value: "uz"
  },
  {
    label: "Uzbek (Latin) (Uzbekistan)",
    value: "uz-UZ"
  },
  {
    label: "Uzbek (Cyrillic) (Uzbekistan)",
    value: "uz-Cyrl-UZ"
  },
  {
    label: "Vietnamese",
    value: "vi"
  },
  {
    label: "Vietnamese (Viet Nam)",
    value: "vi-VN"
  },
  {
    label: "Xhosa",
    value: "xh"
  },
  {
    label: "Xhosa (South Africa)",
    value: "xh-ZA"
  },
  {
    label: "Chinese",
    value: "zh"
  },
  {
    label: "Chinese (S)",
    value: "zh-CN"
  },
  {
    label: "Chinese (Hong Kong)",
    value: "zh-HK"
  },
  {
    label: "Chinese (Macau)",
    value: "zh-MO"
  },
  {
    label: "Chinese (Singapore)",
    value: "zh-SG"
  },
  {
    label: "Chinese (T)",
    value: "zh-TW"
  },
  {
    label: "Zulu",
    value: "zu"
  },
  {
    label: "Zulu (South Africa)",
    value: "zu-ZA"
  }
];
